export type 破棄破損理由区分型 = '破損' | '紛失' | '期限切れ' | '温度管理逸脱' | 'メーカー指示' | '指示変更' | '手技ミス' | '確認ミス' | 'その他';
export const 破棄破損理由区分一覧: 破棄破損理由区分型[] = ['破損', '紛失', '期限切れ', '温度管理逸脱', 'メーカー指示', '指示変更', '手技ミス', '確認ミス', 'その他'];
